import { render, staticRenderFns } from "./project-managements.vue?vue&type=template&id=3496a8d6&"
import script from "./project-managements.vue?vue&type=script&lang=ts&"
export * from "./project-managements.vue?vue&type=script&lang=ts&"
import style0 from "./project-managements.vue?vue&type=style&index=0&id=3496a8d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports